import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/wish-button.ogg'
import _imports_1 from '@/assets/audio/wish-button.mp3'
import _imports_2 from '@/assets/images/wish-button.png'


const _withScopeId = n => (_pushScopeId("data-v-5eae8af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "textClickAudio",
  preload: "auto"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mpeg"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wish-button",
  src: _imports_2
}, null, -1))
const _hoisted_6 = { class: "wish-text" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, _hoisted_4, 512),
    _createElementVNode("div", {
      class: "wish-container",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
    }, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, "Wish ×" + _toDisplayString(_ctx.wishes), 1),
        _createElementVNode("p", {
          class: _normalizeClass({
          red: _ctx.fates < _ctx.wishes && !_ctx.$store.state.settings.infinitePrimos,
        })
        }, [
          _createElementVNode("img", {
            class: "fate-image",
            src: 
            require(`@/assets/images/${
              _ctx.standard ? 'acquaint' : 'intertwined'
            }-fate.webp`)
          ,
            alt: "fate"
          }, null, 8, _hoisted_7),
          _createElementVNode("span", null, "x " + _toDisplayString(_ctx.wishes), 1)
        ], 2)
      ])
    ])
  ], 64))
}